import { createApp } from "vue";
import SocialCheerBtn from "~/components/Articles/SocialCheerBtn";
import FollowBtn from "~/components/Articles/FollowBtn";
import LikeBtn from "~/components/Articles/LikeBtn";
import QuoteToolTip from "~/components/Articles/QuoteToolTip";
import ArticleSpeechForShowPage from "~/components/Articles/ArticleSpeechForShowPage";
import ContentsRightAttachmentDownloadButton from "~/components/Articles/ContentsRightAttachmentDownloadButton";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import "lazysizes";

document.addEventListener("DOMContentLoaded", () => {
  const socialCheerApp = createApp({ components: { SocialCheerBtn } });
  socialCheerApp.mount("#social-cheer");
  const followBtnApp = createApp({ components: { FollowBtn } });
  followBtnApp.use(FloatingVue);
  followBtnApp.mount("#follow-btn");
  const likeBtnApp = createApp({ components: { LikeBtn } });
  likeBtnApp.mount("#like-btn");
  const quoteToolTipApp = createApp({ components: { QuoteToolTip } });
  quoteToolTipApp.mount("#quote-tool-tip");
  const speechApiPcApp = createApp({ components: { ArticleSpeechForShowPage } });
  speechApiPcApp.mount("#speech-api-pc");
  const speechApiSp = createApp({ components: { ArticleSpeechForShowPage } });
  speechApiSp.mount("#speech-api-sp");
  const contentsRightAttachmentDownloadButton = createApp({
    components: {
      ContentsRightAttachmentDownloadButton,
    }
  });
  contentsRightAttachmentDownloadButton.use(FloatingVue);
  contentsRightAttachmentDownloadButton.mount("#contents-right-attachment-download-button-sp");
  const acceptPageViewer = createApp({
    mounted() {
      window.addEventListener("beforeunload", this.createEndArticleViewAcceptPageViewer);
    },
    beforeDestroy() {
      window.removeEventListener("beforeunload", this.createEndArticleViewAcceptPageViewer);
    },
    methods: {
      async createEndArticleViewAcceptPageViewer() {
        // accept_page_viewerがない場合は処理をしない
        if (!document.getElementById("accept_page_viewer")) {
          return;
        }
        try {
          const sendBeacon = window.navigator.sendBeacon.bind(navigator);
          const articleId = document.getElementById("article_id").value;
          const result = sendBeacon(`/api/v1/admins/articles/${articleId}/end_viewing_article_accept_page`);
          if (!result) {
            window.webpackBugsnagClient.notify("承認画面の閲覧終了時間の保存に失敗しました。");
          }
        } catch (e) {
          window.webpackBugsnagClient.notify("承認画面の閲覧終了時間の保存に失敗しました。");
        }
      }
    }
  });
  acceptPageViewer.mount("#accept_page_viewer");
});
